import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  notesOptions,
  healthIssuesOptions,
  activitiesOptions,
} from "../../../constants/dummyData";
import { useSelector, useDispatch } from "react-redux";
import PatientLoader from "../../common/PatientLoader";
import { setDiagnosisDataLogic } from "../../../store/features/patient/patientSlice";
import { getFullName, notify } from "../../../util/helpers";
import { DatePicker, DateRangePicker } from "rsuite";
import cocm from "../../../assets/HelpfulMaterials/CoCM_Labels_Designed.pdf";

const UpdatePatientBHINote = ({ closeModal, isBHI }) => {
  const [customNotes, setCustomNotes] = useState(null);
  const [notesType, setNotesType] = useState({ ...notesOptions[1] });
  const { staffDataLoading, staffData, selectedClinic, user } = useSelector(
    (state) => state.app
  );
  const { bhiLoading, bhiData } = useSelector((state) => state.bhi);
  const [bhiManagers, setBhiManagers] = useState([]);
  const [selectedBHIManagers, setSelectedBhiManagers] = useState([]);
  const [activity, setActivity] = useState([]);
  const [healthIssues, setHealthIssues] = useState(healthIssuesOptions[0]);
  const dispatch = useDispatch();
  const { loading, singlePatientData } = useSelector((state) => state.patient);
  const { beforeToday } = DateRangePicker;
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [activityOptions, setActivityOptions] = useState(activitiesOptions);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (loading) {
      return;
    }
    const headManager = {
      label: getFullName(user),
      value: null,
    };
    if (!staffDataLoading && staffData.length > 0) {
      const clinicians = [
        selectedClinic?.clinic_admin,
        ...selectedClinic?.clinical_staff,
      ];
      const tempStaff = staffData
        .map((staff) => {
          if (clinicians?.includes(staff?.id)) {
            if (staff?.id === user?.id) {
              headManager["value"] = staff;
            }
            return {
              label: getFullName(staff),
              value: staff,
            };
          }
        })
        .filter((item) => {
          if (item) {
            return item;
          }
        });
      setBhiManagers(tempStaff);
      setSelectedBhiManagers(tempStaff[0]);
    }
  }, [loading, bhiLoading, staffDataLoading, staffData]);

  useEffect(() => {
    //! Is this right?
    if (!bhiLoading) {
      setHealthIssues({ label: bhiData?.diagnosis, value: bhiData?.diagnosis });
    }
  }, [bhiLoading]);

  const handleManagerChange = (e) => {
    setSelectedBhiManagers(e);
  };
  const handleActivityChange = (e) => {
    setActivity(e);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let payload;
    if (notesType?.value !== "Billing") {
      let diagnosis =
        notesType?.value !== "BHI" ? notesType.value : healthIssues?.value;
      payload = {
        diagnosis: diagnosis,
        notes: customNotes,
        patient: singlePatientData?.id,
        added_by: selectedBHIManagers?.value?.id,
      };
    } else {
      //it is billing notes type
      const monthYear = new Date(selectedMonth).toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
      payload = {
        activity: activity.label,
        notes: customNotes,
        patient: singlePatientData?.id,
        added_by: selectedBHIManagers?.value?.id,
        month: monthYear,
        duration: duration,
      };
    }
    console.log(payload);
    dispatch(setDiagnosisDataLogic(payload));
    notify("Note added successfully!");
    closeModal();
  };
  const handleMonthSelect = (selectedDate) => {
    console.log("selectedDate: " + selectedDate);
    // Extract the month from the selected date
    const selectedMonth = selectedDate.getMonth();
    setSelectedMonth(selectedMonth);
  };
  return (
    <div className="container-fluid">
      <h4 className="mt-5 primary-text-blue">Add Patient Note</h4>

      {staffDataLoading ? (
        <PatientLoader />
      ) : (
        <form onSubmit={handleSubmit} className="container-fluid p-2 my-3">
          <div className="form-group my-4">
            <label>Select type of Note</label>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "0px",
                  borderBottom: "1px solid #94A3B8",
                  borderRadius: "0px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Select an update"
              classNamePrefix="select"
              name="noteType"
              options={isBHI ? notesOptions : notesOptions.slice(1)}
              value={notesType}
              onChange={(e) => {
                setNotesType(e);
              }}
            />
          </div>
          {notesType?.value === "BHI" && (
            <div className="form-group my-4">
              <label>Behavioral Health Diagnosis Update *</label>
              <Select
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "0px",
                    borderBottom: "1px solid #94A3B8",
                    borderRadius: "0px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                placeholder={healthIssuesOptions[0]}
                classNamePrefix="select"
                name="healthDiagnosis"
                options={healthIssuesOptions}
                // isMulti
                value={healthIssues}
                onChange={setHealthIssues}
                // defaultValue={healthIssuesOptions[0]}
              />
            </div>
          )}
          {notesType?.value === "Billing" && (
            <div className="form-group my-4">
              <label>Billing Month *</label>
              <DatePicker
                placeholder="MMMM YYYY"
                appearance="subtle"
                name="billing_month"
                id="billing_month"
                format="MMMM yyyy"
                oneTap
                // shouldDisableDate={beforeToday()}
                className="custom-datepicker"
                value={selectedMonth}
                //onSelect={handleMonthSelect}
                onChange={setSelectedMonth}
                required
              />
            </div>
          )}

          {notesType?.value === "Billing" && (
            <div className="form-group my-4">
              <label>Activity *</label>
              <Select
                value={activity}
                onChange={handleActivityChange}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "0px",
                    borderBottom: "1px solid #94A3B8",
                    borderRadius: "0px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                // isDisabled={
                //   user?.role !== "CLINIC_ADMIN" || user?.role !== "CLINICAL_STAFF"
                // }
                placeholder="Activity"
                classNamePrefix="select"
                name="activity"
                isClearable={false}
                options={activityOptions}
                required
              />
            </div>
          )}
          {notesType?.value === "Billing" && (
            <div className="form-group my-4">
              <label>
                <a href={cocm} target="_blank" rel="noopener noreferrer">
                  Billing information Document
                </a>
              </label>
            </div>
          )}
          {notesType?.value === "Billing" && (
            <div className="form-group my-4">
              <label>Time spent *</label>
              <input
                type="number"
                min="0"
                step="1"
                pattern="\d+"
                className="form-control"
                placeholder="Enter time spent (in minutes)"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                required
              />
            </div>
          )}
          {notesType?.value !== "Billing" && (
            <div className="form-group my-4">
              <label>Behavioral Health Manager *</label>
              <Select
                value={selectedBHIManagers}
                onChange={handleManagerChange}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "0px",
                    borderBottom: "1px solid #94A3B8",
                    borderRadius: "0px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={
                  user?.role !== "CLINIC_ADMIN" ||
                  user?.role !== "CLINICAL_STAFF"
                }
                placeholder="Dr. John Doe"
                classNamePrefix="select"
                name="doctor"
                isClearable={false}
                options={activitiesOptions}
              />
            </div>
          )}

          <div className="form-group my-4">
            <label>Notes *</label>
            <textarea
              required
              id="notes"
              name="notes"
              placeholder="Anything special you'd like to add ...."
              className="form-control"
              rows="5"
              value={customNotes}
              onChange={(e) => {
                setCustomNotes(e.target.value);
              }}
              style={{ resize: "none" }}
            ></textarea>
          </div>

          <div className="d-flex justify-content-center w-100 container-fluid mb-2 mt-3">
            <button className="btn primary-btn w-100" type="submit">
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default UpdatePatientBHINote;
